import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    workspaces: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Tooltip and accessibility label for navigating to the Home/Workspaces area from the primary navigation */
            workspaces: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspacesButton.workspaces?c=2wjsbag9mz9hy", defaultMessage: "Home" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
